// extracted by mini-css-extract-plugin
export default {"bubbleLoader":"BubbleLoader_bubbleLoader__nniYE","bubble-loader":"BubbleLoader_bubble-loader__KOQPo"};